import { AdminStats } from '../types';

const formatPrice = (cents: number, currency = 'eur') =>
  new Intl.NumberFormat('nl-NL', { style: 'currency', currency: currency.toUpperCase() }).format(cents / 100);

interface Props {
  stats: AdminStats;
}

export const AdminStatsBar = ({ stats }: Props) => {
  const cards = [
    {
      label: 'Totale Omzet',
      value: formatPrice(stats.totalRevenue),
      icon: 'ri-money-euro-circle-line',
      color: 'text-emerald-400',
      bg: 'bg-emerald-500/10 border-emerald-500/20',
    },
    {
      label: 'Bestellingen',
      value: stats.total,
      icon: 'ri-shopping-bag-line',
      color: 'text-violet-400',
      bg: 'bg-violet-500/10 border-violet-500/20',
    },
    {
      label: 'Betaald',
      value: stats.paid,
      icon: 'ri-shield-check-line',
      color: 'text-emerald-400',
      bg: 'bg-emerald-500/10 border-emerald-500/20',
    },
    {
      label: 'Blueprints',
      value: stats.blueprints,
      icon: 'ri-file-download-line',
      color: 'text-fuchsia-400',
      bg: 'bg-fuchsia-500/10 border-fuchsia-500/20',
    },
    {
      label: 'Blueprint Verstuurd',
      value: stats.blueprintsSent,
      icon: 'ri-mail-check-line',
      color: 'text-emerald-400',
      bg: 'bg-emerald-500/10 border-emerald-500/20',
    },
    {
      label: 'Consulten',
      value: stats.consultations,
      icon: 'ri-calendar-check-line',
      color: 'text-violet-400',
      bg: 'bg-violet-500/10 border-violet-500/20',
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-6">
      {cards.map((c) => (
        <div
          key={c.label}
          className={`rounded-2xl border p-4 ${c.bg}`}
        >
          <div className={`w-8 h-8 flex items-center justify-center rounded-lg mb-2 ${c.bg}`}>
            <i className={`${c.icon} text-base ${c.color}`} />
          </div>
          <p className="text-white font-black text-xl leading-none mb-1">{c.value}</p>
          <p className="text-white/40 text-xs">{c.label}</p>
        </div>
      ))}
    </div>
  );
};
